import React from "react";
import "./ToolbarToggleSwitch.scss";

const ToolbarToggleSwitch = ({
  checked = false,
  onChange,
  label,
  className = "",
  disabled = false,
}) => (
  <label
    className={`scfo-toolbar-toggle ${className}`.trim()}
    aria-disabled={disabled}
  >
    <input
      type="checkbox"
      checked={checked}
      disabled={disabled}
      onChange={(e) => onChange?.(e.target.checked, e)}
    />
    <span className="scfo-toolbar-toggle__slider" aria-hidden="true" />
    {label ? <span className="scfo-toolbar-toggle__label">{label}</span> : null}
  </label>
);

export default ToolbarToggleSwitch;
